<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <b-modal id="modalconfirmDelete" ref="modalconfirmDelete" title="Confirm">
      <p>Do you really want to remove the registry?</p>
      <p><b>File:</b> {{ file.originalName }}</p>
      <p><b>Name:</b> {{ file.name }}</p>
      <p><b>Description:</b> {{ file.description }}</p>
      <template slot="modal-footer">
          <b-button variant="primary" class="mr-2" @click="confirmDelete">Confirm</b-button>
          <b-button variant="secondary" @click="hideConfirmDelete">Close</b-button>
      </template>
    </b-modal>
    <b-modal id="modalFile" ref="modalFile" size="lg" title="File" >
        <b-container fluid>
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
                <label>File <span class="text-danger">*</span></label>   
                <div class="input-group"> 
                  <b-form-file v-model="file.file" :state="$v.file.file.$dirty ? !$v.file.file.$error : null" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
                </div>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
                <label>Name <span class="text-danger">*</span></label>   
                <div class="input-group"> 
                  <b-form-input id="name-input" v-model="file.name" :state="$v.file.name.$dirty ? !$v.file.name.$error : null"></b-form-input>
                </div>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
              <label>Description</label>   
              <b-form-textarea id="textarea-default" v-model="file.description" maxlength="500"></b-form-textarea>
            </div>
          </b-col>
        </b-row>
        </b-container>
        <template v-slot:modal-footer>
          <b-button type="submit" variant="primary" class="mr-2" @click="saveFile">Save</b-button>
          <b-button variant="secondary" @click="hideModalFile">Close</b-button>
        </template>
    </b-modal>
    <b-modal id="modalEditFile" ref="modalEditFile" size="lg" title="File" >
        <b-container fluid>
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
                <label>Original Name:</label>   
                <p>{{ file.originalName }}</p>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
                <label>Name <span class="text-danger">*</span></label>   
                <div class="input-group"> 
                  <b-form-input id="name-input" v-model="file.name" :state="$v.file.name.$dirty ? !$v.file.name.$error : null"></b-form-input>
                </div>
            </div>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="12">
            <div class="form-group">
              <label>Description</label>   
              <b-form-textarea id="textarea-default" v-model="file.description" maxlength="500"></b-form-textarea>
            </div>
          </b-col>
        </b-row>
        </b-container>
        <template v-slot:modal-footer>
          <b-button type="submit" variant="primary" class="mr-2" @click="saveEditFile">Save</b-button>
          <b-button variant="secondary" @click="hideModalEditFile">Close</b-button>
        </template>
    </b-modal>
    <div class="card-body">
      <h5 class="card-title">Files</h5>
      <div class="row">
        <div class="col-md-12">
          <b-table hover :items="fileItems" :fields="fileFields">
            <template v-slot:cell(Options)="row">
              <b-button v-b-tooltip.hover title="Download" variant="success" size="xs" @click="downloadFile(row.item)"><i class="fas fa-download"></i></b-button>
              <b-button v-b-tooltip.hover title="Edit" variant="primary" size="xs" class="ml-1" @click="editFile(row.item)"><i class="far fa-edit"></i></b-button>
              <b-button v-b-tooltip.hover title="Remove" variant="danger" size="xs" class="ml-1" @click="deleteFile(row.item)"><i class="far fa-trash-alt"></i></b-button>
            </template>
            <template v-slot:cell(Period)="row">
              <b>Start</b> {{ row.item.StartDate }} <b>End</b> {{ row.item.EndDate }}
            </template>
          </b-table>
          <b-button variant="primary" @click="addFile">Add file</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import axios from 'axios'
import loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

var qs = require('qs')

export default {
  components: { loading },
  mixins: [validationMixin],
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    id: { type: String, default: () => ({}) }
  },
  data () {
    return {
      CurriculumId: this.id,
      GeneralData: {},
      fileFields: [
      {
        key: 'name',
        label: 'Name'
      },
      {
        key: 'description',
        label: 'Description'
      },
      {
        key: 'Options',
        label: 'Options',
        thStyle: { 'word-wrap': 'break-word' },
        thClass: 'text-right',
        tdClass: 'text-right'
      }
      ],
      fileItems: [],
      file: {},
      newFile: false,
      isLoading: false,
      fullPage: false,
      zIndex: 9999
    }
  },
  validations() {
    return {
      file: {
        file: {
          required
        },
        name: {
          required
        }
      }
    }
  },
  created () {
    this.loadFiles()
  },
  methods: {
    ...authMethods,
    checkFileSize () {
      if (!this.file.file) {
        return true
      }
      return (this.file.file.size/1024/1024 < this.agency.maxFileSize)
    },
    loadFiles() {
      this.isLoading = true
      axios.get(appConfig.apiUrl + 'file/curriculum/' + this.CurriculumId,
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        if(response.data) {
          this.fileItems = response.data
        }
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    addFile () {
      this.newFile = true
      this.file = {
        curriculumId: this.CurriculumId
      }
      this.$refs['modalFile'].show()
    },
    saveFile () {
      this.$v.file.$touch()
      if (this.$v.file.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      if (!this.checkFileSize()) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: `The maximum file size allowed is ${this.agency.maxFileSize} MB.`});
        return
      }

      let formData = new FormData();
      formData.append('files', this.file.file);
      formData.append('file.name', this.file.name);
      formData.append('file.curriculumFile[0].curriculumId', this.CurriculumId);

      if(this.file.description) {
        formData.append('file.description', this.file.description );
      }

      this.isLoading = true
      axios.post( appConfig.apiUrl + 'file/save', formData, 
      { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'multipart/form-data' } } )
      .then((response) => {
        this.loadFiles()
        this.$emit('reload-curriculum')
        this.hideModalFile()
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
        this.isLoading = false
      })
    },
    hideModalFile () {
      this.$refs['modalFile'].hide()
      this.$v.file.$reset()
    },
    hideModalEditFile () {
      this.$refs['modalEditFile'].hide()
      this.$v.file.$reset()
    },
    editFile (item) {
      this.file = item
      this.file.file = this.file.originalName
      this.$refs['modalEditFile'].show()
    },
    saveEditFile () {
      this.$v.file.$touch()
      if (this.$v.file.$anyError) {
        this.$notify({group: 'alert', type: 'error', title: 'Form Validation', text: 'Please complete all required fields.'});
        return
      }

      axios.put(appConfig.apiUrl + 'file/update',
        qs.stringify({ file: this.file }),
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Saved Successful.'})
          this.loadFiles()
          this.hideModalEditFile()
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error})
          this.isLoading = false
        })
    },
    downloadFile (item) {
      this.isLoading = true
      axios.get(appConfig.apiUrl + `file/download/${item.id}`,
      { 
        headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' },
        responseType: 'blob'
      })
      .then((response) => {
        if(response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', item.originalName);
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    deleteFile (item) {
      this.file = item
      this.$refs['modalconfirmDelete'].show()
    },
    hideConfirmDelete () {
      this.$refs['modalconfirmDelete'].hide()
    },
    gotoNew () {
      this.$router.push({ name: 'general-data' })
    },
    confirmDelete () {
      this.isLoading = true
      axios.delete(appConfig.apiUrl + `file/${this.file.id}`,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
        .then(response => {
          this.$notify({group: 'alert', type: 'success', title: 'Success', text: 'Deleted Successful.'});
        })
        .catch(error => {
          this.loginCheck(error.response.status)
          this.$notify({group: 'alert', type: 'error', title: 'Request Error', text: error});
        })
        .finally(() => {
          this.loadFiles()
          this.isLoading = false
          this.$emit('reload-curriculum')
          this.hideConfirmDelete()
        })
    }
  }
}
</script>

<style>

</style>
